import { buildProjectSnapshot } from "../core/migrations/projectSnapshot";
import type { FileStoreState } from "../stores/fileStore/types";
import type { Scene } from "../types/scene";

const stableStringify = (value: unknown): string => {
  const seen = new WeakSet<object>();
  return JSON.stringify(value, (_key, nestedValue) => {
    if (!nestedValue || typeof nestedValue !== "object") return nestedValue;
    if (seen.has(nestedValue)) return null;
    seen.add(nestedValue);
    if (Array.isArray(nestedValue)) return nestedValue;
    return Object.keys(nestedValue as Record<string, unknown>)
      .sort()
      .reduce<Record<string, unknown>>((acc, key) => {
        acc[key] = (nestedValue as Record<string, unknown>)[key];
        return acc;
      }, {});
  });
};

export const buildProjectSaveSnapshotHash = (args: {
  scene: Scene;
  fileState: Pick<
    FileStoreState,
    "projectName" | "referencedFiles" | "keyframes" | "keyframeDetails" | "preservedMjcfSections"
  >;
}): string => {
  const snapshot = buildProjectSnapshot({
    scene: args.scene,
    projectName: args.fileState.projectName || "Untitled Scene",
    modelXmlPath: "model.xml",
    referencedFiles: args.fileState.referencedFiles || [],
    keyframes: args.fileState.keyframes || {},
    keyframeDetails: args.fileState.keyframeDetails || {},
    preservedMjcfSections: args.fileState.preservedMjcfSections || {},
  });
  return stableStringify({
    ...snapshot,
    createdAtIso: "",
  });
};
